/*
 * @Descripttion:
 * @Author: olei<wangzheng_jzb@100tal.com>
 * @Date: 2020-09-07 19:55:47
 * @LastEditors: olei<wangzheng_jzb@100tal.com>
 * @LastEditTime: 2020-09-10 16:51:44
 * yach > 1.4.7 已经废弃，目前只保留 sdk 入口兼容 yach 低版本调用
 */
import initAPI from '../../initAPI';
var apiName = 'app.custom.talYoungFilesUpload';
function talYoungFilesUpload(params) {
  initAPI(apiName, {
    params: params
  });
}
export { talYoungFilesUpload };


//////////////////
// WEBPACK FOOTER
// ./node_modules/yach.open.jssdk/es/api/app/custom/talYoungFilesUpload.js
// module id = null
// module chunks = 